export default {
    home: 'Home',
    login: 'Login',
    components: 'Components',
    count_to_page: 'Count-to',
    tables_page: 'Table',
    split_pane_page: 'Split-pane',
    markdown_page: 'Markdown-editor',
    editor_page: 'Rich-Text-Editor',
    icons_page: 'Custom-icon',
    img_cropper_page: 'Image-editor',
    update: 'Update',
    doc: 'Document',
    join_page: 'QQ Group',
    update_table_page: 'Update .CSV',
    update_paste_page: 'Paste Table Data',
    multilevel: 'multilevel',
    directive_page: 'Directive',
    level_1: 'Level-1',
    level_2: 'Level-2',
    level_2_1: 'Level-2-1',
    level_2_3: 'Level-2-3',
    level_2_2: 'Level-2-2',
    level_2_2_1: 'Level-2-2-1',
    level_2_2_2: 'Level-2-2-2',
    excel: 'Excel',
    'upload-excel': 'Upload Excel',
    'export-excel': 'Export Excel',
    tools_methods_page: 'Tools Methods',
    drag_list_page: 'Drag-list',
    i18n_page: 'Internationalization',
    modalTitle: 'Modal Title',
    content: 'This is the modal box content.',
    buttonText: 'Show Modal',
    'i18n-tip': 'Note: Only this page is multi-language, other pages do not add language content to the multi-language package.',
    error_store_page: 'Error Collection',
    error_logger_page: 'Error Logger',
    query: 'Query',
    params: 'Params',
    cropper_page: 'Cropper',
    message_page: 'Message Center',
    tree_table_page: 'Tree Table',
    org_tree_page: 'Org Tree',
    drag_drawer_page: 'Draggable Drawer',
    tree_select_page: 'Tree Selector'
};
